import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as RequiredIcon } from 'assets/images/required.svg';

import s from './field-label.module.scss';

type FieldLabelProps = {
  label?: string;
  isRequired?: boolean;
  /** Содержимое перед подписью, например значок с подсказкой */
  prefix?: ReactNode;
};

/** Подпись поля формы — одна для всех контролов */
export const FieldLabel = ({ label, isRequired, prefix }: FieldLabelProps) => {
  const { t } = useTranslation();

  return (
    <div className={s['wrapper-label']}>
      {prefix}
      <span className={s['label']}>{t(label ?? '')}</span>
      {isRequired && <RequiredIcon className={s['required']} />}
    </div>
  );
};
